import { Button, Stack } from '@mui/material'
import { CarrierType } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { ListIcon, TrainIcon, useMinimalsTheme, VesselIcon } from '@tom-ui/ui'

export type ViewType = 'list' | 'plan'

interface ViewToggleButtonsProps {
  currentView: ViewType
  carrierType?: CarrierType
  onListClick: () => void
  onPlanClick: () => void
}

export const ViewToggleButtons = ({
  currentView,
  carrierType,
  onListClick,
  onPlanClick,
}: ViewToggleButtonsProps) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const isList = currentView === 'list'
  const isPlan = currentView === 'plan'

  return (
    <Stack
      display={'inline-block'}
      direction={'row'}
      spacing={0.5}
      bgcolor={theme.palette.grey[200]}
      borderRadius={theme.customRadius.medium}
      padding={1}
    >
      <Button
        onClick={onListClick}
        startIcon={<ListIcon />}
        sx={{
          backgroundColor: isList ? theme.palette.common.white : theme.palette.grey[200],
          color: isList ? theme.palette.text.primary : theme.palette.text.secondary,
          borderRadius: theme.customRadius.medium,
        }}
        data-cy='view-toggle-btn-list'
      >
        {t('list', 'List')}
      </Button>

      <Button
        onClick={onPlanClick}
        startIcon={carrierType === 'Train' ? <TrainIcon /> : <VesselIcon />}
        sx={{
          backgroundColor: isPlan ? theme.palette.common.white : theme.palette.grey[200],
          color: isPlan ? theme.palette.text.primary : theme.palette.text.secondary,
          borderRadius: theme.customRadius.medium,
        }}
        data-cy='view-toggle-btn-plan'
      >
        {t('plan', 'Plan')}
      </Button>
    </Stack>
  )
}
